import React from 'react';
import { Pressable, Image } from 'react-native';
import { View, YStack, SizableText, XStack, Text, Separator, Label, TextArea } from 'tamagui';
import moment from 'moment';
import { LinearGradient } from 'tamagui/linear-gradient';

// Helper functions for user avatars
const correctStorageUrl = (url: string | undefined) => {
  if (!url) return null;
  return url.replace(
    'https://storage.googleapis.com/smartsaas-avatar-store/',
    'https://storage.cloud.google.com/smartsaas-avatar-store/'
  );
};

const getUserDisplayName = (user: any) => {
  if (!user) return null;
  if (user.firstName && user.lastName) return `${user.firstName} ${user.lastName}`;
  if (user.firstName) return user.firstName;
  if (user.lastName) return user.lastName;
  if (user.email) return user.email;
  return 'Unknown User';
};

// User Avatar Component
const UserAvatar = ({ user, size = 16 }: { user?: any; size?: number }) => {
  if (!user) return null;

  const avatarUrl = correctStorageUrl(user.avatar);
  const userName = getUserDisplayName(user);

  if (avatarUrl) {
    return (
      <Image
        source={{ uri: avatarUrl }}
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          marginRight: 4,
          borderWidth: 1,
          borderColor: 'rgba(255, 255, 255, 0.6)',
        }}
        onError={() => console.log('Error loading avatar for', userName)}
      />
    );
  }

  // Fallback to initials
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        marginRight: 4,
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.6)',
      }}
    >
      <Text style={{ color: '#ffffff', fontSize: size * 0.5, fontWeight: '700' }}>
        {userName?.charAt(0).toUpperCase()}
      </Text>
    </View>
  );
};

export const SocialEventMarking = ({ dot, eventInfo, index }: { dot?: any, eventInfo: any, index?: number }) => {
  return (
    <LinearGradient colors={['$red10', '$yellow10']} start={[0, 1]}
      end={[0, 0]} style={{ flex: 1, alignSelf: "stretch", flexDirection: 'row', alignItems: 'center', paddingHorizontal: 8, paddingVertical: 4 }}>
      {eventInfo[index]?.user && (
        <UserAvatar user={eventInfo[index].user} size={16} />
      )}
      <SizableText
        userSelect='none'
        style={{
          flex: 1,
          justifyContent: "center",
          verticalAlign: "middle",
          textAlign: "left",
          fontWeight: 'bold',
          color: 'white',
          fontSize: 12,
          ...dot?.customTextStyle
        }}
        numberOfLines={1}
        ellipsizeMode="tail"
      >
        {eventInfo[index]?.title || ""}
      </SizableText>
    </LinearGradient>
  )
}

export const SocialEventContent = ({ eventInfo, index }: { eventInfo: any, index?: number }) => {
  return (
    <YStack flex={1} paddingHorizontal={15} alignSelf='stretch' gap={"$1.5"}>
      <Text style={{ fontSize: 24, lineHeight: 20 }}>{eventInfo[index]?.title || ""}</Text>
      <Separator />
      {
        eventInfo[index]?.allDay ? <Text>All Day</Text> : (
          <XStack alignSelf={"stretch"} flex={1} alignContent='space-around'>
            <View style={{ flex: 1 }}>
              <Label>Scheduled For:</Label>
            </View>
            <Text style={{ flex: 1 }}>{moment(eventInfo[index]?.startDate).format('HH:MMa').toString()}</Text>
          </XStack>
        )
      }
      <Separator />
      <YStack gap={"$1.5"}>

      </YStack>
      {
        eventInfo[index]?.attachments?.map((attachment, index) => (
          <Text key={index}>{attachment}</Text>
        ))
      }
    </YStack>
  )
}
